import React, { Component } from "react";
import { render, hydrate } from "react-dom";
import { Switch, Route, Link } from "react-router";
// import { Switch, Route } from "react-router";
import { BrowserRouter } from "react-router-dom";

import App from "../server/views/home";
import DefaultLayout from "../server/views/layouts/default";
// import Upload from "../server/views/upload";
// import Login from "../server/views/login";

import routes from "../server/modules/routes";

import fetch from "fetch-everywhere";

import ScrollToTop from "../server/views/components/scrollToTop";

hydrate(
  <BrowserRouter>
    <ScrollToTop>
      <DefaultLayout routes={routes} />
    </ScrollToTop>
  </BrowserRouter>,
  document
);

//React-Router 3
//render(<Router history={browserHistory} routes={routes} />, document);
